import {useMemo, useState, useEffect} from 'react';
// @ts-expect-error
import type {Match} from 'react-router-dom';

import type {ComparisonRangeType} from 'nutshell-core/types';

import {appHistory} from '../../../history';

import {ReportTabs} from '../report-tabs';
import type {ReportURLParams} from '../report-types';

import {ActivityReportActivities} from './activity-report-activities';
import {ActivityReportSummary} from './activity-report-summary';

type Props = {
    match: Match | null | undefined;
    comparisonType: ComparisonRangeType | null | undefined;
    location: any;
    urlParams: ReportURLParams<'leads'>;
    onParamPush: (arg1: any) => void;
    onParamChange: (arg1: any, shouldMerge: boolean) => void;
};

export function ActivityReportDetailViewContainer(props: Props) {
    const [stickyHeaderTopPx, setStickyHeaderTop] = useState<number | null | undefined>(null);
    const isActivitiesActive = props.match && props.match.params.tab === 'activities';

    const tabs = useMemo(
        () => [
            {
                id: 'summary',
                label: 'Summary',
                pathname: '/reports/activity',
                exact: true,
            },
            {
                id: 'activities',
                label: 'Activities',
                pathname: '/reports/activity/activities',
                exact: true,
            },
        ],
        []
    );

    const tabContents = [
        {
            id: 'summary',
            body: (
                <ActivityReportSummary
                    filters={props.urlParams.filter}
                    comparisonType={props.comparisonType}
                    activeSort={props.urlParams.sort}
                    stickyHeaderTop={stickyHeaderTopPx}
                    onParamChange={props.onParamChange}
                />
            ),
        },
        {
            id: 'activities',
            body: (
                <ActivityReportActivities
                    onParamPush={props.onParamPush}
                    selectedPage={
                        isActivitiesActive && props.urlParams.page
                            ? Number(props.urlParams.page)
                            : 1
                    }
                    stickyHeaderTop={stickyHeaderTopPx}
                    filters={props.urlParams.filter}
                />
            ),
        },
    ];

    // Find matching tab based on current pathname
    // If no matching tab is found, redirect to the first tab
    const matchingTab = tabs.find((tab) => tab.pathname === props.location.pathname);

    useEffect(() => {
        if (!matchingTab) {
            appHistory.replace({
                // @ts-expect-error
                pathname: tabs[0].pathname,
                search: props.location.search,
            });
        }
    }, [matchingTab, props.location.pathname, props.location.search, tabs]);

    return (
        <ReportTabs
            // @ts-expect-error
            selectedTab={matchingTab ? matchingTab.id : tabs[0].id}
            location={props.location}
            onStickyChange={setStickyHeaderTop}
            tabContents={tabContents}
            tabs={tabs}
        />
    );
}
